import React from 'react';
import { FormControl, Select, MenuItem, Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const CustomDropdown = ({ options, selectedValue, onChange, label }) => {
  return (
    <FormControl
      size="small"
      sx={{
        minWidth: '160px',
        maxWidth: '220px',
      }}
    >
      <Select
        value={selectedValue}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          height: '48px',
          borderRadius: '12px',
          backgroundColor: '#ffffff',
          color: '#111827',
          fontWeight: 600,
          fontSize: '14px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
          border: '1px solid #e5e7eb',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#f9fafb',
            border: '1px solid #d1d5db',
            boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            padding: '0 16px',
            paddingRight: '36px !important',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
          },
          '& .MuiSvgIcon-root': {
            color: '#6b7280',
            right: '12px',
            transition: 'transform 0.2s ease',
          }
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '12px',
              boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
              mt: 1,
              border: '1px solid #f3f4f6',
              '& .MuiList-root': {
                padding: '8px',
              },
              '& .MuiMenuItem-root': {
                fontSize: '14px',
                fontWeight: 500,
                padding: '10px 16px',
                borderRadius: '8px',
                margin: '2px 0',
                transition: 'background-color 0.2s',
                '&:hover': {
                  backgroundColor: '#f3f4f6',
                },
                '&.Mui-selected': {
                  backgroundColor: '#ecfdf5',
                  color: '#059669',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#d1fae5',
                  }
                }
              }
            },
          },
        }}
        renderValue={(selected) => {
          const selectedOption = options.find(option => option.value === selected);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, overflow: 'hidden' }}>
              {label && <span style={{ color: '#6b7280', fontWeight: 500 }}>{label}:</span>}
              <span style={{
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: '#111827',
                fontWeight: 600
              }}>
                {selectedOption ? selectedOption.label : 'Select'}
              </span>
            </Box>
          );
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropdown;
